import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home'
import ZwPage from '@/views/zwPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/zw',
      name: 'zwpage',
      component: ZwPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js